import * as React from "react";
import { useContext } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import axios from "axios";
import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";
import { EditProjectContext } from "../../../EditProjectContext";
import SharedDialog, { SharedDialogControls } from "../../../../../Layout/Dialog/SharedDialog";
import { ProjectViewModel } from "../../../../ViewModel/ProjectViewModel";
import SaveProject from "../../../SaveProject";
import { projectUrls } from "../../../../../URL/ApplicationUrls";
import { combinedUrls } from "../../../../../URL/functions";

function RemoveRoute({ route }: { route: FtlRouteViewModel }) {
  const { project, reloadData } = useContext(EditProjectContext);
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  const handleDialogOpen = () => {
    setIsOpen(true);
  };

  const handleDialogClose = () => {
    setIsOpen(false);
  };

  const removeRouteFromProject = async (
    routeId: number,
    // eslint-disable-next-line @typescript-eslint/no-shadow
    project: ProjectViewModel
  ) => {
    handleDialogClose();

    await SaveProject({ project });

    const url = combinedUrls(
      projectUrls.projectWithId(project.ProjectId).apiUrl,
      `/RemoveFtlRoute/${routeId}`
    );

    const fetchPromise = axios.delete(url);
    const response = await toast.promise(fetchPromise, {
      pending: "Loading",
      success: `Route ${route.RouteNumber} has been removed from project`,
      error: "Unknown error while removing ftl route from project",
    });
    if (response.status !== 200) {
      throw new Error("Network response was not ok");
    }

    reloadData();
  };
  return (
    <>
      <Button onClick={handleDialogOpen}>
        <FontAwesomeIcon icon={faClose} />
      </Button>
      <SharedDialog
        title="Remove route"
        subtitle={`Are you sure you want to remove route ${route.RouteNumber} from this project?`}
        isOpen={isOpen}
        handleClose={handleDialogClose}
        width="sm"
      >
        <SharedDialogControls>
          <button
            onClick={handleDialogClose}
            type="button"
            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
          >
            Cancel
          </button>
          <button
            onClick={() => removeRouteFromProject(route.RouteId, project)}
            type="submit"
            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
          >
            Ok
          </button>
        </SharedDialogControls>
      </SharedDialog>
    </>
  );
}

export default RemoveRoute;
